import { ComponentInfoState, initialComponentInfoState } from './component-info/component-info.state';
import { createFeatureSelector } from '@ngrx/store';
import { initialProviderState, ProviderState } from './provider/provider.state';
import { RouterReducerState } from '@ngrx/router-store';
import { initialRouterState } from './router/router.state';
import { initialLoggedInUserState, LoggedInUserState } from './logged-in-user/logged-in-user.state';

export interface SharedState {
  componentInfoState: ComponentInfoState;
  providerState: ProviderState;
  routerState: RouterReducerState;
  loggedInUserState: LoggedInUserState;
}

export const initialSharedState: SharedState = {
  componentInfoState: initialComponentInfoState,
  providerState: initialProviderState,
  routerState: initialRouterState,
  loggedInUserState: initialLoggedInUserState,
};

export const SHARED_FEATURE_KEY = 'sharedState';

export const getSharedFeatureState = createFeatureSelector<SharedState>(SHARED_FEATURE_KEY);
